//one-card-activeproblem/card.tsx
//Import Dependencies
import * as React from 'react';
import Table from "antd/lib/table";

import {
  Card
} from 'one-ui-card/src/card';

import {
  AlertsCardProps
} from './props';

import {
  AlertsModal
} from './model';

import {
  buildGearActionsMenu,
} from 'one-ui-gear/src/actions';

import {
  CardNoData
} from 'one-ui-card';

import {
  CardLight,
} from 'one-ui-card/src/card-light';

import {
  checkCardHasError,
  TriageCardErrorMsg
} from 'one-card-notification';

import { useCtx } from "one-ui-provider";


/**
 *  card renders all patient related active problemsdata
 * @param props component properties
 * @returns JSX code for Active Problems
 */
export const AlertsSummaryCard = <M extends AlertsModal>(
  props: AlertsCardProps<M>
) => {
  const {
    model,
    title,
    gearActions = [],
  } = props;

  const {
    alerts
  } = model || {};

  let activeproblemsUI;

  console.log("-----Alerts",alerts)

  const { log, settings } = useCtx();
  const { uisettings: { medicalproblemtablecolconfig } } = settings;


  let result;
  if (checkCardHasError("Alerts") && alerts.length === 0) {
    result =
      <>
        <TriageCardErrorMsg />
      </>
  }

  if (alerts?.length === 0) {
    result = 
    <>
        <CardNoData/>
    </>
}
  else {
    result = (
      <div className="line-description">
          <div className="line-description__item">
              <div className="line-description__item-title">Total Alerts</div>
              <div className="line-description__item-note">{alerts[0]?.totalalerts}</div>
          </div>
      </div>
  )
  }

  return (
    <CardLight
    title={title}
    gearActions={
      buildGearActionsMenu(
          gearActions,
      )
  }
    body={
        result
    }
/>
  );
};